export default "/images/vendor/flag-icon-css/flags/4x3/ba.svg?7097f2f878560a3debc6d5fd27807596";